import axios from 'axios';
import putLog from 'actions/putLog';

const errorOrResponseFromError = (error) => error.response || error;

export default function promiseMiddleware({ dispatch, getState }) {
  return (next) => (action) => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }
    const {
      promise, types, afterSuccess, afterFailure, ...rest
    } = action;
    if (!action.promise) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;
    next({
      ...rest, isPromise: true, promiseStatus: 'REQUEST', type: REQUEST,
    });

    const onFulfilled = (result) => {
      if (result instanceof Error) {
        Promise.reject(errorOrResponseFromError(result));
      } else {
        next({
          ...rest, result, isPromise: true, promiseStatus: 'SUCCESS', type: SUCCESS,
        });
        if (afterSuccess) {
          afterSuccess(dispatch, getState, result);
        }
      }
    };
    const onRejected = (error) => {
      const errorOrResponse = errorOrResponseFromError(error);
      next({
        ...rest, error: errorOrResponse, isPromise: true, promiseStatus: 'FAILURE', type: FAILURE,
      });

      if (errorOrResponse.data && errorOrResponse.data.errCode) {
        const { intl: { messages }, authentication: { isAuthenticated } } = getState();
        const isUnauthenticatedWarnRequest = error.status === 401 && error.config.url.includes('/log');
        const shouldReportAuthError = !isAuthenticated && !messages[`aio.errorCode.${errorOrResponse.data.errCode}`] && !isUnauthenticatedWarnRequest;
        if (shouldReportAuthError) {
          const logMessage = {
            ID: null,
            errCode: error.data.errCode,
            msg: `WEB2.0_UI: Unknown errorCode from AIO for ${COUNTRY}`,
          };
          dispatch(putLog(logMessage, 'warn'));
        }
      }

      if (afterFailure) {
        afterFailure(dispatch, getState, error);
      }
    };
    return promise(axios)
      .then(onFulfilled, onRejected)
      .catch((error) => {
        console.error('MIDDLEWARE ERROR:', error);
        onRejected(errorOrResponseFromError(error));
      });
  };
}
